import { AfterViewInit, Component, ElementRef, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter, take } from 'rxjs/operators';
import { SegmentService } from 'src/app/services/segment/segment.service';
import { VisibilityService } from 'src/app/services/visibility.service';

@UntilDestroy()
@Component({
  selector: 'app-integrations-upsell',
  templateUrl: './integrations-upsell.component.html',
  styleUrls: ['./integrations-upsell.component.scss'],
})
export class IntegrationsUpsellComponent implements AfterViewInit {
  private prevScrollY = 0;
  private scrollDirection: 'top' | 'bottom' = 'bottom';

  readonly logos = [
    { src: 'assets/images/billing/integrations-card/Bamboo.svg', alt: 'Bamboo HR' },
    { src: 'assets/images/billing/integrations-card/Peopleforce.svg', alt: 'Peopleforce' },
    { src: 'assets/images/billing/integrations-card/Rippling.svg', alt: 'Rippling' },
    { src: 'assets/images/billing/integrations-card/ZohoPeople.svg', alt: 'Zoho People' },
    { src: 'assets/images/billing/integrations-card/Xero.svg', alt: 'Xero' },
    { src: 'assets/images/billing/integrations-card/Gusto.svg', alt: 'Gusto' },
    { src: 'assets/images/billing/integrations-card/VacationTracker.png', alt: 'Vacation Tracker' },
  ];

  constructor(
    private readonly router: Router,
    private readonly segment: SegmentService,
    private readonly visibilityService: VisibilityService,
    private readonly elementRef: ElementRef<HTMLElement>,
  ) {}

  ngAfterViewInit(): void {
    this.prevScrollY = window.scrollY;

    this.visibilityService.elementInSight(this.elementRef.nativeElement)
      .pipe(filter(visible => visible), take(1), untilDestroyed(this))
      .subscribe(() => {
        this.segment.trackInAppEvents('Integrations Card Viewed', {
          pagename: 'billing page',
          scroll: this.scrollDirection,
        });
      });
  }

  @HostListener('window:scroll')
  onScroll(): void {
    const currentY = window.scrollY;
    if (currentY !== this.prevScrollY) {
      this.scrollDirection = currentY > this.prevScrollY ? 'bottom' : 'top';
      this.prevScrollY = currentY;
    }
  }

  navigateToIntegrations(): void {
    this.segment.trackInAppEvents('Link Click', {
      linkname: 'Explore Integrations',
      linklocation: 'Integrations awareness card',
      pagename: 'billing page',
      linktype: 'button',
    });
    this.router.navigate(['/integrations']);
  }
}
